module.exports = __webpack_public_path__ + "img/blogs_layout1.e9ae3f98.png";